<template>
    <v-dialog v-model="ChangeClientModal" width="60vh" height="95vh">
        <div class="row justify-content-center" style="background-color:white;width:60vh; height:100%">
            <div class="col-12" style="width:100%; height:100%">
                <div class="p-4">
                    <h5>Изменить клиента в заказе</h5>
                    <div class="row">
                        <div
                            class="col d-flex align-items-center justify-content-center"
                        >
                            <div
                                class="d-flex flex-column align-items-center w-100"
                            >
                                <v-tabs
                                        v-model="currentClientType"
                                        centered
                                        color="basil"
                                        hide-slider
                                        active-class="tab-active"
                                >
                                    <v-tab
                                            v-for="({name, slug}, index) in clientsType"
                                            :key="slug + index"
                                            class="tab"
                                    >
                                        {{ name }}
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="currentClientType">
                                    <v-tab-item>
                                        <v-card>
                                            <div
                                                    id="pills-home"
                                                    class="pills-home"
                                                    role="tabpanel"
                                                    aria-labelledby="pills-home-tab"
                                            >
                                                <div class="identity__client">
                                                    <div
                                                            class="form-inline d-block text-center"
                                                    >
                                                        <label
                                                                class="my-1 mr-2"
                                                                for="phone"
                                                        >Телефон:</label
                                                        >
                                                        <input
                                                                id="phone"
                                                                class="form-control m-2"
                                                                type="tel"
                                                                placeholder="Телефон"
                                                                v-model="phone"
                                                                v-mask="'+7(###) ###-##-##'"
                                                        />
                                                    </div>
                                                    <div
                                                            class="form-inline d-block text-center"
                                                    >
                                                        <label
                                                                class="my-1 mr-2"
                                                                for="discountCard"
                                                        >или бонусная карта:</label
                                                        >
                                                        <the-mask
                                                                id="discountCard"
                                                                class="form-control m-2"
                                                                placeholder="1000..."
                                                                autofocus
                                                                v-model="discountCard"
                                                                type="text"
                                                                mask="#######"
                                                        ></the-mask>
                                                    </div>
                                                    <div
                                                            v-if="
                                                    client.customer.phone !=
                                                        '' ||
                                                        client.customer.name !=
                                                            ''
                                                "
                                                    >
                                                        <p class="text-center">
                                                            Клиент:
                                                            <b
                                                            >{{
                                                                this.client.customer
                                                                .name
                                                                }}
                                                                {{
                                                                this.client.customer
                                                                .surname
                                                                }}</b
                                                            >
                                                            Скидка:
                                                            <b>
                                                              {{
                                                                Math.trunc(
                                                                (this.client
                                                                .discount
                                                                .value +
                                                                this.client
                                                                .additional_discount
                                                                .value) *
                                                                100
                                                                )
                                                                }}%
                                                            </b>
                                                        </p>
                                                    </div>
                                                    <div v-if="clientError">
                                                        <p
                                                                class="text-center text-danger"
                                                        >
                                                            {{ clientError }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="btn-group">
                                                    <button
                                                            class="btn btn-danger mr-5"
                                                            v-bind:class="{
                                                    disabled: client.active == 1
                                                }"
                                                            @click.prevent="
                                                    anonymousOrder()
                                                "
                                                    >
                                                        Без скидки
                                                    </button>
                                                    <button
                                                            class="btn btn-success"
                                                            v-bind:class="{
                                                    disabled:
                                                        client.customer.phone ==
                                                            '' &&
                                                        client.customer.name ==
                                                            ''
                                                }"
                                                            @click.prevent="recalcOrder()"
                                                    >
                                                        Продолжить со скидкой
                                                    </button>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card>
                                            <div
                                                    class="tab-content pt-2"
                                                    id="pills-tabContent"
                                            >

                                                <div
                                                        id="pills-profile1"
                                                        role="tabpanel"
                                                        class="pills-profile-tab"
                                                        aria-labelledby="pills-profile-tab"
                                                >
                                                    <div class="form-group">
                                                        <v-select
                                                                v-model="chosenLegal"
                                                                :items="legalClients"
                                                                outlined
                                                                item-text="name"
                                                                return-object
                                                                @change="loadLegalCars"
                                                        >
                                                        </v-select>
                                                    </div>
                                                    <div
                                                            :class="{
                                                                'car-scroll show active': chosenLegal
                                                             }"
                                                            id="pills-profile"
                                                            role="tabpanel"
                                                            aria-labelledby="pills-profile-tab"
                                                    >
                                                        <!-- <div class="form-group d-flex align-items-center" :class="{ 'error-border' : inputErrors.selectedPlate && clientCars.length === 0}">
                                                            <span style="padding-top: 12px; margin-right: 5px;">
                                                                <input
                                                                name="plate"
                                                                ref="plate"
                                                                v-validate="'uniquePlate|min:8|max:9'"
                                                                maxlength="10" class="form-control input input--small"
                                                                type="text"
                                                                placeholder="Номер авто"
                                                                @input="resetVlidation"
                                                                v-model="plate"
                                                                />
                                                                <p style="font-size: small; padding: 5px; margin-bottom: 0; min-width: 175px;">
                                                                <span>{{ errors.first('plate') }}</span>
                                                                </p>
                                                            </span>
                                                            <button
                                                                class="btn-custom btn--small btn ml-1"
                                                                :class="{ disabled: !plate || !chosenMark || !chosenModel }"
                                                                :disabled="!formValid"
                                                                @click.prepend="addClientCar()"
                                                            >
                                                                Добавить
                                                            </button>
                                                        </div> -->
                                                        <div
                                                                class="form-group d-flex"
                                                                :class="{
                                                    'error-border':
                                                        inputErrors.selectedPlate
                                                }"
                                                        >
                                                            <v-item-group
                                                                    v-model="selectedPlate"
                                                                    active-class="active"
                                                            >
                                                                <v-container
                                                                        class="pl-0 pt-0 mt-0"
                                                                >
                                                                    <v-item
                                                                            v-for="(car,
                                                            i) in clientCars"
                                                                            :key="i"
                                                                            class="mb-3"
                                                                    >
                                                                        <label
                                                                                class="btn btn-numbers m-1"
                                                                                @click="
                                                                    loadCarDetails(
                                                                        [car, i]
                                                                    )
                                                                "
                                                                        >
                                                                            <div
                                                                                    class="btn-numbers__wrapper d-flex flex-column"
                                                                            >
                                                                                <div
                                                                                        class="plate-number font-size-24 mr-1"
                                                                                >
                                                                                    {{
                                                                                    car
                                                                                    .pivot
                                                                                    .plate_number
                                                                                    }}
                                                                                </div>
                                                                                <div
                                                                                        class="plate-car-model"
                                                                                >
                                                                                    {{
                                                                                    car.mark
                                                                                    }}
                                                                                    {{
                                                                                    car.model
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                        </label>
                                                                    </v-item>
                                                                </v-container>
                                                            </v-item-group>
                                                            <!-- <p class="bubble bubble-top text-small">Для добавления нового а/м введите гос. номер в формате <b>X123XX456</b>, затем выберите марку и модель а/м кликнув в поле <b>Авто</b>. Проверьте, что выбран <b>тип а/м</b> и нажмите кнопку <b>"Добавить"</b>.</p> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>



<script>
import { mapGetters } from "vuex";

export default {
    components: {},
    created() {
        this.currentClientType = this.clientType
        // this.$store.dispatch('fetchUserData')
    },
    async mounted() {
        this.$store.dispatch("fetchLegalClients");
    },
    data() {
        return {
            phone: "",
            discountCard: "",
            plate: "",
            selectedPlate: null,
            clientsType: [
                {
                    slug: '',
                    name: 'Клиент',
                }, {
                    slug: '',
                    name: 'Компания'
                },
            ],
            currentClientType: '',
            inputErrors: {
                selectedPlate: false
            },
        };
    },
    computed: {
        ...mapGetters([
            "clientType",
            "client",
            "clientError",
            "legalClients",
            "clientCars",
            "order",
            "cart",
            "runflat",
            "frameVehicle",
            "chosenPromocode",
            "chosenServices",
            "chosenMark",
            "chosenModel"
        ]),
        ...mapGetters("shift",[ "shiftData" ]),
        ChangeClientModal: {
          get() {
            return this.$store.getters.ChangeClientModal;
          },
          set(newVal) {
            this.$store.dispatch("setChangeClientModal", newVal);
          },
        },
        chosenLegal: {
            get() {
              // нельзя так там есть this.updateOrder(); он все обновляет потом опять chosenLegal гетится и опять обновляет
              // this.loadLegalCars();
              return this.$store.getters.chosenLegal;
            },
            set(value) {
                this.$store.commit("updateChosenLegal", value);
            }
        },
        chosenMark: {
            get() {
                return this.$store.getters.chosenMark;
            },
            set(value) {
                this.$store.commit("updateChosenMark", value);
            }
        },
        chosenModel: {
            get() {
                return this.$store.getters.chosenModel;
            },
            set(value) {
                this.$store.commit("updateChosenModel", value);
            }
        },
        carType: {
            get() {
                return this.$store.getters.carType;
            },
            set(value) {
                this.$store.commit("updateCarType", value);
            }
        }
    },
    methods: {
        showClientChangeModal() {
            this.$modal.show("ChangeClientModal");
        },
        hideClientChangeModal() {
          this.ChangeClientModal = false;
            // this.$modal.hide("ChangeClientModal");
        },
        getClient(searchString, type) {
            this.$store.dispatch("fetchClient", { searchString, type });
        },
        recalcOrder() {
            this.$store
                .dispatch("fetchPricesWithCartItems", {
                    cart: this.chosenServices,
                    promocode: this.chosenPromocode,
                    client: this.client
                })
                .then(() => {
                    this.updateOrder();
                });
            this.hideClientChangeModal();
        },
        anonymousOrder() {
            this.$store.commit("resetClient");
            this.$store.commit("anonymousClient");
            this.recalcOrder();
            this.hideClientChangeModal();
        },
        legalOrder() {
            this.$store.commit("loadClientFromLegal");
            this.$router.push("/order/clientcard");
        },
        resetVlidation() {
            if (!this.plate) this.$validator.reset();
        },
        formValid() {
            return Object.keys(this.fields).every(
                field => this.fields[field].valid
            );
        },
        loadLegalCars() {
            this.$store.commit("loadClientFromLegal");
            this.$store.dispatch("fetchClientCars");
            this.updateOrder();
        },
        loadCarDetails([car, index]) {
            this.selectedPlate = index;
            this.filter = car.mark + " " + car.model;
            this.chosenMark = car.mark;
            this.chosenModel = car.model;
            this.carType = car.car_type_id;
            this.client.plate = car.pivot.plate_number;
            this.client.car_id = car.pivot.id;
            this.chosenPlate = car.pivot.plate_number;

            this.updateOrder();
            this.hideClientChangeModal();
        },
        updateOrder() {
            this.$store.dispatch("updateOrder", {
                cart: this.cart,
                client: this.client,
                clientPhone: this.client.customer.phone ?? "",
                promocode: this.chosenPromocode,
                shift: this.shiftData,
                status: this.order.status,
                order_id: this.order.id,
                mark: this.chosenMark ?? "",
                model: this.chosenModel ?? "",
                runflat: this.runflat,
                frameVehicle: this.frameVehicle,
                employee: this.choosenEmployee ?? ""
            });
        }
    },
    watch: {
        phone() {
            while (
                this.phone.charAt(0) === "8" ||
                this.phone.charAt(0) === "7"
            ) {
                return (this.phone = this.phone.substr(1));
            }
            if (this.phone.length == 17) {
                this.getClient(
                    this.phone.replace(/[^0-9.]/g, "").substr(1),
                    "phone"
                );
            }
            if (this.phone.length < 17) {
                this.$store.commit("resetClient");
            }
        },
        discountCard() {
            if (this.discountCard.length == 7) {
                this.getClient(this.discountCard, "discountCard");
                // this.$store.commit('nextStep', 2)
            }
        },
        client: {
            handler() {
                if (this.client.discount.card_number) {
                    this.discountCard = this.client.discount.card_number;
                }
            },
            deep: true
        }
    }
};
</script>
<style scoped>
    .pills-home {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .v-window {
        width: 100%;
    }
    .pills-profile-tab {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .tab-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .tab-active{
        color: #fff !important;
        background-color: #006228 !important;
        box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);
    }
    .tab {
        margin: 0 5px;
        color: #1976d2;
        background-color: #00c851;
    }
.btn-numbers {
    margin: 0;
    display: flex;
    border-radius: 10px;
    padding: 3px 8px 3px 12px;
    font-family: "Istok Web Regular";
    background-color: #ffffff;
    width: 165px;
    border: 1px solid black;
    border-radius: 15px;
}
    .car-scroll {
        height: 600px;
        overflow: auto;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .btn-numbers__wrapper {
        text-align: left;
    }
</style>
